export const BRAND = {
  name: "Pancha Healing",
  tagline: "Your crystals. Prescribed.",
  whatsapp: "917471116999",
  whatsappDisplay: "+91 74711 16999",
  email: "hello@panchahealing.com",
  upi: "madhurummeratia@ybl",
  razorpayLink: "https://rzp.io/rzp/juEeseJW",
  adminPassword: process.env.REACT_APP_ADMIN_PASSWORD || "",
};

// Single product, single price
export const PRODUCT = {
  id: "sacred",
  name: "Pancha Healing Sacred Crystal Bracelet",
  price: 1599,
  includes: [
    "Personalised crystal bracelet",
    "Sacred numerology report",
    "Velvet pouch",
    "Raw crystal chip",
    "A6 prescription card",
    "Ships across India",
  ],
};

// Backward compatibility for any code still referencing PRODUCTS
export const PRODUCTS = { sacred: PRODUCT, signature: PRODUCT };

export const WRIST_SIZES = [
  { value: "small", label: "Small", description: "5.5 to 6 inch" },
  { value: "medium", label: "Medium", description: "6 to 6.5 inch" },
  { value: "large", label: "Large", description: "6.5 to 7 inch" },
];

export const ORDER_STATUSES = [
  "Pending Payment",
  "Payment Confirmed",
  "Prescription Sent",
  "Making",
  "Dispatched",
  "Delivered",
];

export const ELEMENT_STYLES = {
  earth: { bg: "#E8F5E9", border: "#A5D6A7", text: "#1B5E20" },
  water: { bg: "#E3F2FD", border: "#90CAF9", text: "#0D47A1" },
  fire: { bg: "#FFF3E0", border: "#FFCC80", text: "#E65100" },
  air: { bg: "#F3E5F5", border: "#CE93D8", text: "#4A148C" },
  ether: { bg: "#EDE7F6", border: "#B39DDB", text: "#311B92" },
};

export const ELEMENT_ORDER = ["earth", "water", "fire", "air", "ether"];

export const MAKING_CHECKLIST = [
  { key: "pulled", label: "Crystals pulled from inventory" },
  { key: "cleansed", label: "Crystals cleansed under moonlight or Selenite" },
  { key: "panchaSelected", label: "5 Pancha beads selected (8mm) - Earth, Water, Fire, Air, Ether" },
  { key: "prescriptionSelected", label: "Prescription beads selected (8mm)" },
  { key: "strung", label: "Bracelet strung - Pancha beads spaced equally with prescription beads between" },
  { key: "sized", label: "Sized for customer wrist" },
  { key: "cardPrinted", label: "Prescription card printed (A6)" },
  { key: "reportPrinted", label: "Sacred numerology report printed" },
  { key: "rawCrystal", label: "Raw crystal chip selected" },
  { key: "boxPacked", label: "Box packed - report + bracelet in velvet pouch + raw crystal + prescription card" },
  { key: "photoTaken", label: "Photo taken before sealing" },
  { key: "whatsappSent", label: "Prescription sent to customer WhatsApp" },
  { key: "emailSent", label: "Report sent to customer email" },
  { key: "readyDispatch", label: "Ready to dispatch" },
];

// Element mapping for inventory grouping (for admin inventory tracker).
// Maps each crystal to its element. Multi-element crystals get their primary element.
export const CRYSTAL_ELEMENT = {
  // Earth
  "Black Tourmaline": "earth", "Jade": "earth", "Red Jasper": "earth",
  "Smoky Quartz": "earth", "Bloodstone": "earth", "Emerald": "earth",
  "Malachite": "earth", "Green Aventurine": "earth", "Peridot": "earth",
  // Water
  "Rose Quartz": "water", "Moonstone": "water", "Aquamarine": "water",
  "Blue Lace Agate": "water", "Pearl": "water", "Labradorite": "water",
  "Rhodonite": "water",
  // Fire
  "Carnelian": "fire", "Pyrite": "fire", "Sunstone": "fire", "Tiger Eye": "fire",
  "Citrine": "fire", "Garnet": "fire",
  // Air
  "Clear Quartz": "air", "Sodalite": "air", "Lapis Lazuli": "air",
  "Yellow Topaz": "air", "Celestite": "air", "Turquoise": "air",
  "Lepidolite": "air",
  // Ether
  "Amethyst": "ether", "Selenite": "ether", "Fluorite": "ether",
  "Black Obsidian": "ether", "Obsidian": "ether",
};
